var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useService, useTimezone } from "@tenderd/track-web-utils";
import { Card, Col, Empty, Spin } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import Chart from "react-apexcharts";
import { useTranslation } from "../../../translations/hooks";
import { RecentViolationsTKeys, } from "../../../translations/keys";
export var RecentViolations = function (props) {
    var i18n = useTranslation().i18n;
    var dayjs = useTimezone().dayjs;
    var groupId = props.groupId;
    var service = useService();
    var _a = __read(useState([]), 2), recentViolations = _a[0], setRecentViolations = _a[1];
    var _b = __read(useState([]), 2), categories = _b[0], setCategories = _b[1];
    var getRecentViolations = function (projectId) { return __awaiter(void 0, void 0, void 0, function () {
        var form;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    form = {
                        startDate: dayjs().tz().add(-7, "days").startOf("day").toDate(),
                        endDate: dayjs().tz().add(-1, "days").endOf("day").toDate(),
                    };
                    return [4 /*yield*/, service.safety.getRecentTelematicsViolationsPerDay(projectId, form).then(function (data) {
                            setRecentViolations(data);
                            var uniqueViolationTypes = data.map(function (recentViolation) { return recentViolation.violation_date; });
                            setCategories(uniqueViolationTypes);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getRecentViolations(groupId);
    }, [groupId]);
    var transformedData = useMemo(function () {
        if (recentViolations) {
            return transformData(recentViolations);
        }
        return [];
    }, [recentViolations]);
    function transformData(input) {
        var mapping = {
            'geo-in': 'Geofence events',
            'geo-out': 'Geofence events',
            'restricted-geofence-entry': 'Geofence events',
            'idling': 'Idling',
            'overspeed': 'Overspeed',
            'harsh-acceleration': 'Harsh driving',
            'harsh-breaking': 'Harsh driving',
            'harsh-cornering': 'Harsh driving',
            // 'battery-voltage': 'Battery Voltage',
            // 'engine-temperature': 'Engine Temperature',
            // 'engine-rpm': 'Engine RPM',
        };
        var output = {};
        input.forEach(function (item, i) {
            item.violations.forEach(function (violation) {
                var name = mapping[violation.violation_type];
                if (!name) {
                    return;
                }
                if (!output[name]) {
                    output[name] = Array(input.length).fill(0);
                }
                output[name][i] += violation.violation_count;
            });
        });
        return Object.entries(output).map(function (_a) {
            var _b = __read(_a, 2), name = _b[0], data = _b[1];
            return ({ name: name, data: data });
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Card, { headStyle: { fontSize: '16px' }, className: "recent-violations", title: i18n.t(RecentViolationsTKeys.recentViolations), bodyStyle: { height: 400, display: "flex", paddingTop: 10 } },
            React.createElement(Col, { span: 16 },
                recentViolations ? null : React.createElement(Spin, { tip: i18n.t(RecentViolationsTKeys.loading) }),
                recentViolations.length ? (React.createElement(Chart, { options: {
                        chart: {
                            type: 'bar',
                            height: 350,
                            stacked: true,
                        },
                        dataLabels: {
                            enabled: false
                        },
                        plotOptions: {
                            bar: {
                                horizontal: false
                            },
                        },
                        xaxis: {
                            categories: categories,
                        },
                        yaxis: {
                            title: {
                                text: undefined
                            },
                        },
                        fill: {
                            opacity: 1
                        },
                        legend: {
                            position: 'top',
                            horizontalAlign: 'left',
                            offsetX: 40
                        }
                    }, series: transformedData, type: "bar", height: 350 })) : (React.createElement(Empty, { description: i18n.t(RecentViolationsTKeys.noRecentViolations) }))))));
};
export default RecentViolations;
